/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.spacer",
    title: "Email Spacer",
    description: "A fixed-height vertical spacer row for controlling whitespace in platform emails.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {
        "height": {
            title: "Height",
            type: "number",
            description: "The vertical space in pixels. Defaults to 24.",
            required: false,
            default: 24
        }
    }
});

var $ = require("../../../uam/scafolding.js");

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.spacer",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    options = options || {};
    var height = parseInt(options.height, 10);
    if (!(height > 0)) { height = 24; }
    if (height > 400) { height = 400; } // sane ceiling

    // Zeroed font-size/line-height + a non-breaking space is the client-safe
    // way to force vertical space (empty cells collapse in some clients).
    var html = `<tr>
  <td style="height:${height}px;line-height:${height}px;font-size:0;">&nbsp;</td>
</tr>`;

    var text = "\n";

    return { html, text };
};
